import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import trainingManual from '../assets/Sports_Athletic_Consent_Platform_Staff_User_Manual.v2.pdf';

const HelpMenu = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleTraining = () => {
        const link = document.createElement('a');
    link.href = trainingManual;
    link.download = 'Sports_Athletic_Consent_Platform_Staff_User_Manual.v2.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    handleClose();
    }

    return (
        <div>
            <Button
                id="help-button"
                aria-controls={open ? 'help-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                <HelpOutlineIcon />
            </Button>
            <Menu
                id="help-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                className='menuhelp'
            >
                <MenuItem onClick={handleTraining}  className='menuhelptrin'>Manual</MenuItem>
            </Menu>
        </div>
    )

}

export default HelpMenu;